module.exports = __webpack_public_path__ + "img/50x50_sari.c2e3ecb7.gif";